import { useState } from "react";
import { Outlet } from "react-router-dom";
import Sidebar from "../components/layout/Sidebar";
import MobileHeader from "../components/MobileHeader";
import KakaoAdFit from "../components/KakaoAdfit";

export default function DashboardLayout() {
  const [mobileNavOpen, setMobileNavOpen] = useState(false);

  return (
    <div className="relative isolate flex min-h-screen w-full bg-zinc-100 dark:bg-zinc-950">
      {/* 데스크톱 고정 사이드바 */}
      <Sidebar mode="desktop" />

      {/* 오른쪽 컬럼: 헤더 + 메인 + 푸터 (세로 배치) */}
      <div className="flex min-h-screen flex-1 flex-col">
        {/* 모바일 상단 헤더 */}
        <MobileHeader onMenu={() => setMobileNavOpen(true)} />

        {/* 모바일 드로어 사이드바 */}
        <Sidebar mode="drawer" open={mobileNavOpen} onClose={() => setMobileNavOpen(false)} />

        {/* Main outlet */}
        <main className="flex flex-1 min-h-0 flex-col pt-[4rem] pr-2 pl-2 sm:pl-2 lg:pt-2 lg:pl-64">
          <div className="grow min-h-0 rounded-lg bg-white p-4 sm:p-6 lg:p-10 shadow-xs ring-1 ring-zinc-950/5 dark:bg-zinc-900 dark:ring-white/10 dark:shadow-none text-zinc-900 dark:text-zinc-100">
            <Outlet />
          </div>
        </main>

        <div className="block h-[100px] lg:hidden mt-3">
          <KakaoAdFit unit="DAN-ldLbyiWOyLnNAcLT" width={320} height={100} />
        </div>

        <div className="block h-[100px] lg:hidden mt-3">
          <KakaoAdFit unit="DAN-AKQ46vzmjbDI3J1H" width={320} height={100} />
        </div>

        {/* Footer */}
        <footer className="bg-transparent">
          <div
            className="
              mx-auto w-full
              px-3 py-3
              sm:px-4 sm:py-1
              lg:pl-64 lg:pr-10 lg:py-1
              text-center lg:text-right text-xs sm:text-xs text-zinc-500 dark:text-zinc-400
            "
          >
            © {new Date().getFullYear()} Arkive. All rights reserved. This site is not associated with Smilegate RPG & Smilegate Stove.
          </div>
        </footer>
      </div>
    </div>
  );
}
